/**
 * Rotating accent palette for icon tiles.
 *
 * Grids of identical primary-tinted icon chips are what make a page read as
 * monotonous — cycling a colour per card gives each section visual variety
 * while staying inside one coherent palette. Index in with `accent(i)`.
 */
export interface Accent {
  /** Tile background (light tint). */
  bg: string;
  /** Icon / text colour on that tint. */
  fg: string;
}

export const ACCENTS: Accent[] = [
  {bg: '#EEF2FF', fg: '#4F46E5'}, // indigo
  {bg: '#ECFEFF', fg: '#0891B2'}, // cyan
  {bg: '#FDF2F8', fg: '#DB2777'}, // pink
  {bg: '#FFF7ED', fg: '#EA580C'}, // orange
  {bg: '#F0FDF4', fg: '#16A34A'}, // green
  {bg: '#F5F3FF', fg: '#7C3AED'}, // violet
];

export const accent = (i: number): Accent => ACCENTS[i % ACCENTS.length];
